import request from '@/utils/request'
import { errorMessages } from '@vue/compiler-sfc'
// let preBase = ''
let preBase = 'mixApi'

// 厦门国际银行-存款达标领取活动-登录
export const login = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/login`,
    method: 'post',
    data,
    custom: true,
    hideLoading: true,
  })
}
// 厦门国际银行-存款达标领取活动-查询用户信息
export const getUserInfo = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/getUserInfo`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
  })
}
// 厦门国际银行-存款达标领取活动-达标查询
export const standardQuery = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/standardQuery`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 厦门国际银行-存款达标领取活动-报名
export const signUp = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/signUp`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 厦门国际银行-存款达标领取活动-领取奖品校验
export const checkReceive = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/checkReceive`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 厦门国际银行-存款达标领取活动-领取奖品
export const receive = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/receive`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
    custom: true,
  })
}

// 厦门国际银行-存款达标领取活动-领取记录分页
export const getRecordPages = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/getRecordPages`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
  })
}
// 厦门国际银行-存款达标领取活动-添加埋点记录
export const addPointData = (data) => {
  return request({
    url: `${preBase}/xibDepositStandard/addPointData`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankXibSaveMoneyToken'),
    data,
    hideLoading: true,
  })
}
